import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { PermissionTypesEnum } from '@api/ringil-api.v2';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import CreateSupplierNotification, {
  SupplierNotificationForm,
} from '@app/pages/customer/supplier-notification/CreateSupplierNotification.tsx';
import { emptyOrder as emptyFrameworkOrder } from '@components/framework/orders/common.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const CreateSupplierNotificationPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();

  // Config-driven page: STATUS/TRANSPORTATION_TYPE/CARGO start empty so the company's SN config default prefill is authoritative (not a hardcoded app default).
  const initialData: SupplierNotificationForm = {
    transportationType: null,
    attachments: [],
    cargoType: null,
    containerInfo: null,
    customsTypeCode: null,
    referralCode: '',
    shipmentId: null,
    orders: [emptyFrameworkOrder(true)],
    companyId: null,
    supplierId: null,
    specialRequirementIds: [],
    supplierLocationId: null,
    customerLocationId: null,
    shipmentStateCode: null,
    notifyData: { notifyUsersDependsOnRole: true },
    supplierDeliverySlots: { dayWithInterval: [], timezoneId: null },
    customerDeliverySlots: { dayWithInterval: [], timezoneId: null },
    counterPartyNotifyPersonsIds: [],
    labels: [],
  };

  return (
    <>
      <ResponsiveLayout
        title={tr(`create-shipment.createSupplierNotification`, `Create aviso`)}
        oneOfPermission={[PermissionTypesEnum.PERMISSION_SN_EFXX_CREATE]}
      >
        <CreateSupplierNotification initialData={initialData} />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(CreateSupplierNotificationPage);
